const linkStyle = { color: "white" };

const CityUnlockPrivacyPolicy = ({ appName = "City Unlock" }) => {
  return (
    <div id="content">
      <p>
        {`My Fortuna LLC built the ${appName} app as a Commercial app. This SERVICE is provided by My Fortuna LLC and is intended
          for use as is. `}
      </p>
      <p>
        {" "}
        This page is used to inform visitors regarding our policies with the
        collection, use, and disclosure of Personal Information if anyone
        decided to use our Service.
      </p>
      <p>
        {" "}
        If you choose to use our Service, then you agree to the collection and
        use of information in relation to this policy. The Personal Information
        that we collect is used for providing and improving the Service. We will
        not use or share your information with anyone except as described in
        this Privacy Policy.
      </p>
      <p>
        {`The terms used in this Privacy Policy have the same meanings as in our `}
        <a href="/terms-of-service/city-unlock/" style={linkStyle}>
          Terms of Service
        </a>
        {` for ${appName}, unless otherwise defined in this Privacy Policy. `}
      </p>

      <p>
        <strong>Summary</strong>
      </p>
      <p>
        {`${appName} records the streets you walk, run or drive so it can show
        how much of your city you have unlocked. To do that it uses your
        precise location, including in the background while a session that you
        started is running. Your routes stay private to your account. Other
        users can only see what is described under “What Other Users Can See”
        below. We do not sell your personal data and the app does not show
        third-party advertising. `}
      </p>

      <p>
        <strong>Information Collection and Use</strong>
      </p>
      <p>
        <em>Account information.</em>
        {` You sign in to ${appName} with your Google account. When you do, we
        receive and store your name, your email address and your Google profile
        picture. We use them to create and secure your account, to identify you
        as the owner of the data stored in it, and to show your name and
        profile picture next to the photos you share. They are not shown on
        leaderboards (see “Leaderboards” below). Your email address is never
        shown to other users, and we do not use it for advertising. `}
      </p>
      <p>
        <em>Location.</em>
        {` ${appName} collects your device's precise (GPS) location. We use it
        to find the city you are in, to show your position on the map, to
        record which streets you cover during a walk, run or drive, to mark a
        place of a collection you follow as visited when you stay next to it
        with the app open, and to pin a photo to the place where you took it. `}
      </p>
      <p>
        {`When you start a walk, run or drive, ${appName} keeps collecting your
        location while the app is in the background or your phone is locked,
        until you stop that session. On Android a running session appears as
        an ongoing notification when notifications are allowed. Outside of a
        session that you started, the app does not collect your location in the
        background. `}
      </p>
      <p>
        {`From your location we store: the street segments you have unlocked in
        each city; for each session its start and end time, whether it was on
        foot or by car, its distance and a simplified line of the route you
        took; and the places of your collections that you have visited. This
        history is stored in your account and is not shown to other users. You
        can turn location access off at any time in your device settings, but
        the app cannot unlock streets without it. `}
      </p>
      <p>
        <em>Photos and comments.</em>
        {` ${appName} uses your camera when you choose to pin a photo to the
        map. Each time, you choose whether the photo is shared with everyone or
        kept private. For a shared photo we store the picture, your comment,
        the location where it was pinned and the time, together with your name
        and profile picture, and all of this is visible to other users of the
        app. For a private photo we store the picture, your optional note, its
        location and the time, and only you can see it. Please do not share
        photos or comments that reveal personal information about you or about
        other people. `}
      </p>
      <p>
        <em>Leaderboards.</em>
        {` When you unlock streets in a city or visit places of a collection,
        your totals (the distance and percentage of the city you have unlocked
        on foot and by car, and the number of places you have visited) are
        added to that city's leaderboards, which other users of the app can
        see. Your leaderboard entries do not show your Google name or profile
        picture. By default they show a made-up name and a picture generated
        by the app. You can choose a leaderboard name of your own, which we
        store in your account and show on your entries instead. You can also
        hide yourself from the leaderboards at any time from your profile: your
        entries are then removed, and no new ones are added until you choose
        to appear on them again. `}
      </p>
      <p>
        <em>Purchases.</em>
        {` ${appName} Max is a subscription sold through Google Play and the
        Apple App Store. The payment is handled entirely by the store: we never
        receive or store your card or other payment details. We receive and
        store an identifier of the purchase, the product and plan, its status
        and its expiry date, so that we can turn Max on for your account and
        keep it up to date. `}
      </p>
      <p>
        <em>Sharing your progress.</em>
        {` When you use the Share button, the app creates a picture of your
        progress on your device and hands it to the app you pick in your
        phone's share sheet. We do not send it anywhere ourselves. `}
      </p>
      <p>
        <em>Reports.</em>
        {` If you report another user's post, we store the report, the reason
        you chose and the identifier of your account so that we can review it. `}
      </p>
      <p>
        <em>Data kept on your device.</em>
        {` To work quickly and without a connection, the app keeps a copy of
        your city's map and streets, your progress, your settings and any
        session that has not been saved to your account yet on your device.
        Uninstalling the app removes this copy. `}
      </p>

      <p>
        <strong>What Other Users Can See</strong>
      </p>
      <ul>
        <li>Your name and profile picture, on photos you share;</li>
        <li>
          Unless you hide yourself from the leaderboards, your leaderboard name
          (a made-up one unless you choose your own), its generated picture,
          and your leaderboard totals for a city and for its collections;
        </li>
        <li>
          The photos you choose to share with everyone, with their comment,
          location and time.
        </li>
      </ul>
      <p>
        {`Other users cannot see your email address, your live location, your
        routes and sessions, the map of the streets you have unlocked (unless
        you share a picture of it yourself), or your private photos. `}
      </p>

      <p>
        <strong>Legal Basis for Processing (GDPR)</strong>
      </p>
      <p>
        {`Under the EU and UK General Data Protection Regulation (GDPR), we
        process your account information, location, photos, leaderboard
        entries and purchase records because it is necessary for the
        performance of the contract we enter into with you when you create an
        account and use the Service (Article 6(1)(b)). We process diagnostic,
        analytics and report data on the basis of our legitimate interests in
        keeping the Service reliable, safe and free of abuse (Article 6(1)(f)).
        Access to your location and camera is also controlled by the
        permissions of your device, which you can withdraw at any time. `}
      </p>

      <div>
        <p>
          <strong>Third-Party Services</strong>
        </p>
        <p>
          {" "}
          The app does use third-party services that may collect information
          used to identify you.{" "}
        </p>
        <p>
          {`The map is built from OpenStreetMap data. When you look at the map,
          your device downloads map images for the area you are viewing from a
          map tile server (OpenStreetMap's, or another map provider's). When
          you ask the app to find your city, your current coordinates are sent
          to OpenStreetMap's Nominatim search service to look up the city you
          are in, and when you search for a city, the text you type is sent to
          it. These requests carry your device's IP address, as any internet
          request does, but not your name, email address or account. `}
        </p>
        <p>
          {" "}
          Link to the privacy policy of third-party service providers used by
          the app
        </p>
        <ul>
          <li>
            <a
              href="https://www.google.com/policies/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              Google Play Services and Google Sign-In
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/policies/analytics"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              Google Analytics for Firebase
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/support/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              Firebase (Authentication, Cloud Firestore, Cloud Storage,
              Crashlytics and Remote Config)
            </a>
          </li>
          <li>
            <a
              href="https://www.apple.com/legal/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              Apple App Store
            </a>
          </li>
          <li>
            <a
              href="https://osmfoundation.org/wiki/Privacy_Policy"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              OpenStreetMap Foundation
            </a>
          </li>
        </ul>
      </div>
      <p>
        <strong>Log Data</strong>
      </p>
      <p>
        {" "}
        We want to inform you that whenever you use our Service, in a case of an
        error in the app we collect data and information (through third-party
        products) on your phone called Log Data. This Log Data may include
        information such as your device Internet Protocol (“IP”) address, device
        name, operating system version, the configuration of the app when
        utilizing our Service, the time and date of your use of the Service, and
        other statistics.{" "}
      </p>
      <p>
        {`We use Google Analytics for Firebase and Firebase Crashlytics to
        understand how the app is used and to diagnose crashes so we can keep
        ${appName} working reliably. For crash reporting, your account's internal
        identifier (not your name or email address) may be attached to a crash
        report so we can investigate the issue. This diagnostic data is
        processed on our behalf and is not used to advertise to you. `}
      </p>
      <p>
        <strong>Cookies</strong>
      </p>
      <p>
        {" "}
        Cookies are files with a small amount of data that are commonly used as
        anonymous unique identifiers. These are sent to your browser from the
        websites that you visit and are stored on your device's internal memory.{" "}
      </p>
      <p>
        {" "}
        This Service does not use these “cookies” explicitly. However, the app
        may use third-party code and libraries that use “cookies” to collect
        information and improve their services. You have the option to either
        accept or refuse these cookies and know when a cookie is being sent to
        your device. If you choose to refuse our cookies, you may not be able to
        use some portions of this Service.{" "}
      </p>
      <p>
        <strong>Service Providers</strong>
      </p>
      <p>
        {" "}
        We may employ third-party companies and individuals (data processors)
        due to the following reasons:{" "}
      </p>

      <ul>
        <li>To facilitate our Service;</li>
        <li>To provide the Service on our behalf;</li>
        <li>To perform Service-related services; or</li>
        <li>To assist us in analyzing how our Service is used.</li>
      </ul>
      <p>
        {`Our account, database, file storage, authentication, crash-reporting
        and analytics functions are provided by Google Firebase, which acts as
        a data processor and stores your account, location history and photos
        on our behalf. Your data may be stored and processed in the United
        States and in other countries where these providers operate. These
        providers may have access to the information needed to perform their
        tasks for us, but they are obligated not to disclose or use it for any
        other purpose. We do not sell your personal data, and we do not share
        your location history or email address with third parties for their own
        purposes. We may disclose information when the law requires it, or when
        it is necessary to protect the safety of our users or of the public. `}
      </p>
      <p>
        <strong>Your Data Protection Rights</strong>
      </p>
      <p>
        {`If you are located in the European Economic Area or the United Kingdom,
        you have rights over the personal data we hold about you. These include
        the right to access your data, to correct it, to erase it, to restrict
        or object to its processing, and to data portability. You also have the
        right to lodge a complaint with your local data protection authority.
        Depending on where you live, you may have similar rights under your
        local law, and we will honor them in the same way. To exercise any of
        these rights, or to ask any question about how we handle your data,
        contact us at support@myfortuna.app. `}
      </p>
      <p>
        <strong>Data Retention and Deleting Your Data</strong>
      </p>
      <p>
        {`We keep your account information, location history, photos and
        leaderboard entries for as long as your account remains active so we
        can provide the Service. `}
      </p>
      <p>
        {`You can delete a photo you shared or a private photo at any time from
        within the app, which removes it together with its picture. On the free
        plan the app keeps your streets in one city at a time: when you change
        city, and after the app has asked you to confirm, the streets you
        unlocked in the city you leave and your leaderboard entry there are
        erased. `}
      </p>
      <p>
        {`You can delete your account at any time from within ${appName} (Profile,
        then Delete account). This permanently deletes your account record,
        your name, email address and profile picture, your unlocked streets,
        sessions and routes, visited places, leaderboard entries, private
        photos, every photo and comment you shared, and the link between your
        account and your store purchases. If you cannot use the app, you can
        also ask us to delete your account and its data by writing to
        support@myfortuna.app from the email address of the account. `}
      </p>
      <p>
        {`Deleting your account does not cancel a ${appName} Max subscription:
        cancel it in your Google Play or App Store subscriptions first. The
        store keeps its own record of your purchases under its own policy.
        Reports you sent about other users' posts may be kept as a record of
        moderation, and crash and analytics data is kept by those services for
        a limited period under their own retention settings. `}
      </p>
      <p>
        <strong>Security</strong>
      </p>
      <p>
        {" "}
        We value your trust in providing us your Personal Information, thus we
        are striving to use commercially acceptable means of protecting it. But
        remember that no method of transmission over the internet, or method of
        electronic storage is 100% secure and reliable, and we cannot guarantee
        its absolute security.{" "}
      </p>
      <p>
        <strong>Links to Other Sites</strong>
      </p>
      <p>
        {" "}
        This Service may contain links to other sites and apps, for example to
        open directions to a place in a maps app. If you click on a third-party
        link, you will be directed to that site. Note that these external sites
        are not operated by us. Therefore, we strongly advise you to review the
        Privacy Policy of these websites. We have no control over and assume no
        responsibility for the content, privacy policies, or practices of any
        third-party sites or services.{" "}
      </p>
      <p>
        <strong>Children’s Privacy</strong>
      </p>
      <div>
        <p>
          {`${appName} is not made for children and is not directed to them. You
          may use the app only if you are at least 13 years old and have also
          reached the age at which you can consent on your own to the
          processing of your personal data in the country where you live (the
          “age of digital consent”, which is 13 in the United States and
          between 13 and 16 in the European Economic Area and the United
          Kingdom, depending on the country). We do not knowingly allow anyone
          under that age to create an account, record their location or post
          photos, and we do not knowingly collect their personal information. `}
        </p>
        <p>
          {`Because the app is not intended for children, it does not ask for
          your age when you sign in. If we learn that an account belongs to a
          child under the age of digital consent, whether from a parent or
          guardian, from a report, from what was posted or in any other way, we
          will close the account and delete the personal information collected
          through it, including its location history, photos and leaderboard
          entries. If you are a parent or guardian and you believe that your
          child has used ${appName}, please contact us at
          support@myfortuna.app so that we can do this. `}
        </p>
      </div>

      <p>
        <strong>Changes to This Privacy Policy</strong>
      </p>
      <p>
        {" "}
        We may update our Privacy Policy from time to time. Thus, you are
        advised to review this page periodically for any changes. We will notify
        you of any changes by posting the new Privacy Policy on this page.{" "}
      </p>
      <p>This policy is effective as of 2026-10-12</p>
      <p>
        <strong>Contact Us</strong>
      </p>
      <p>
        {" "}
        If you have any questions or suggestions about our Privacy Policy, do
        not hesitate to contact us at support@myfortuna.app.{" "}
      </p>
    </div>
  );
};

export default CityUnlockPrivacyPolicy;
